document.addEventListener('DOMContentLoaded', function () {
	const HARBOUR_INTERNATIONAL_COOKIE = 'harbour_international_acknowledged';
	const HARBOUR_EU_COOKIE = 'harbour_eu_acknowledged';
	const HARBOUR_AU_COOKIE = 'harbour_au_acknowledged';
	const HARBOUR_AU_STORE_URL = 'https://shopharbour.com.au';
	const HARBOUR_AU_HOSTNAME = 'shopharbour.com.au';
	const GEOIP_RETRY_DELAY = 1000; // 1 second
	const COOKIE_EXPIRY_DAYS = 5;
	const EU_COOKIE_EXPIRY_DAYS = 1;
	const AU_COOKIE_EXPIRY_DAYS = 5;
	const HARBOUR_MENA_SESSION_STARTED_COOKIE = 'harbour_mena_session_started';
	const HARBOUR_MENA_SESSION_SHOWN_COOKIE = 'harbour_mena_session_shown';
	const MENA_POPUP_DELAY = 20000;
	const pageArrivalTime = Date.now();
	// Middle East & North Africa: distributed by SANIPEX GROUP
	const MENA_COUNTRY_CODES = [
		'DZ', 'EG', 'LY', 'MA', 'TN', // North Africa
		'BH', 'IQ', 'IL', 'JO', 'KW', 'LB', 'OM', 'PS', 'QA', 'SA', 'AE', 'YE', // Middle East
	];
	const MAX_RETRIES = 3;
	const EU_LANGUAGE_LABELS = {
		en: 'English',
		de: 'Deutsch',
		nl: 'Nederlands',
		sv: 'Svenska',
		fr: 'Français',
		it: 'Italiano',
		pt: 'Português',
		el: 'Ελληνικά',
		es: 'Español',
		ar: 'العربية',
		ja: '日本語',
		ko: '한국어',
		zh: '中文'
	};
	const EU_LANGUAGE_FLAGS = {
		en: '\u{1F1FA}\u{1F1F8}',
		de: '\u{1F1E9}\u{1F1EA}',
		nl: '\u{1F1F3}\u{1F1F1}',
		sv: '\u{1F1F8}\u{1F1EA}',
		fr: '\u{1F1EB}\u{1F1F7}',
		it: '\u{1F1EE}\u{1F1F9}',
		pt: '\u{1F1F5}\u{1F1F9}',
		el: '\u{1F1EC}\u{1F1F7}',
		es: '\u{1F1EA}\u{1F1F8}',
		ar: '\u{1F1F8}\u{1F1E6}',
		ja: '\u{1F1EF}\u{1F1F5}',
		ko: '\u{1F1F0}\u{1F1F7}',
		zh: '\u{1F1E8}\u{1F1F3}'
	};

	let retryCount = 0;
	let popupElement = null;
	let euPopupElement = null;
	let euWelcomePopupElement = null;
	let auWelcomePopupElement = null;
	let menaWelcomePopupElement = null;
	let savedSitePreferenceApplied = false;

	// Cache DOM elements
	function getPopupElement() {
		if (!popupElement) {
			popupElement = document.getElementById('geoip-popup-container');
		}
		return popupElement;
	}

	function getEUPopupElement() {
		if (!euPopupElement) {
			euPopupElement = document.getElementById('geoip-eu-popup-container');
		}
		return euPopupElement;
	}

	function getEUWelcomePopupElement() {
		if (!euWelcomePopupElement) {
			euWelcomePopupElement = document.getElementById('geoip-eu-welcome-popup-container');
		}
		return euWelcomePopupElement;
	}

	function getAUWelcomePopupElement() {
		if (!auWelcomePopupElement) {
			auWelcomePopupElement = document.getElementById('geoip-au-welcome-popup-container');
		}
		return auWelcomePopupElement;
	}

	function getMENAWelcomePopupElement() {
		if (!menaWelcomePopupElement) {
			menaWelcomePopupElement = document.getElementById('geoip-mena-welcome-popup-container');
		}
		return menaWelcomePopupElement;
	}

	function isCurrentlyOnAUStore() {
		const host = (window.location.hostname || '').toLowerCase();
		return host === HARBOUR_AU_HOSTNAME || host.endsWith('.' + HARBOUR_AU_HOSTNAME);
	}

	function getCookie(name) {
		const value = `; ${document.cookie}`;
		const parts = value.split(`; ${name}=`);
		if (parts.length === 2) return parts.pop().split(';').shift();
		return null;
	}

	function setCookie(name, value, days) {
		let expires = '';
		if (days) {
			const date = new Date();
			date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
			expires = '; expires=' + date.toUTCString();
		}
		document.cookie = name + '=' + (value || '') + expires + '; path=/; SameSite=Lax';
	}

	function applyEUVisitorFlag() {
		document.documentElement.classList.add('eu-visitor');
		// Dispatch event so other scripts can react to EU visitor detection
		document.dispatchEvent(new CustomEvent('harbour:eu-visitor-detected'));
	}

	function normalizeLanguageCode(code) {
		if (!code) return '';
		return code.toString().trim().toLowerCase().split('-')[0];
	}

	function getLanguageLabelFromCode(code) {
		const normalized = normalizeLanguageCode(code);
		return EU_LANGUAGE_LABELS[normalized] || '';
	}

	function getLanguageFlagFromCode(code) {
		const normalized = normalizeLanguageCode(code);
		return EU_LANGUAGE_FLAGS[normalized] || '\u{1F1FA}\u{1F1F8}';
	}

	function setEULanguageTriggerLabel(label, code) {
		if (!label) return;
		const normalized = normalizeLanguageCode(code);
		const flag = getLanguageFlagFromCode(code);
		document.querySelectorAll('[data-eu-language-trigger="true"]').forEach(function(trigger) {
			const codeEl = trigger.querySelector('[data-language-code]');
			const flagEl = trigger.querySelector('[data-language-flag]');
			const labelEl = trigger.querySelector('[data-language-label]');
			if (codeEl) {
				codeEl.textContent = normalized.toUpperCase();
			}
			if (flagEl) {
				flagEl.textContent = flag;
			}
			if (labelEl) {
				labelEl.textContent = label;
			}
		});
	}

	function getCurrentLanguageCode() {
		if (window.Weglot && typeof window.Weglot.getCurrentLang === 'function') {
			return window.Weglot.getCurrentLang();
		}

		const hashMatch = window.location.hash.match(/weglot-([a-z]{2})/i);
		if (hashMatch) {
			return hashMatch[1];
		}

		const langAttr = document.documentElement.getAttribute('lang');
		if (langAttr) {
			return langAttr;
		}

		return '';
	}

	function syncEULanguageTriggerLabel() {
		const currentCode = getCurrentLanguageCode();
		const label = getLanguageLabelFromCode(currentCode);
		if (label) {
			setEULanguageTriggerLabel(label, currentCode);
		}
	}

	function bindWeglotLanguageListener() {
		if (!window.Weglot || typeof window.Weglot.on !== 'function') {
			return false;
		}
		window.Weglot.on('languageChanged', function(newLanguage) {
			const label = getLanguageLabelFromCode(newLanguage);
			if (label) {
				setEULanguageTriggerLabel(label, newLanguage);
			}
		});
		return true;
	}

	function removeRegionSections(regionToRemove) {
		// Remove sections that don't match the visitor's region
		document.querySelectorAll('[data-region-visibility="' + regionToRemove + '"]').forEach(function(section) {
			// Remove the parent shopify-section wrapper if it exists, otherwise remove the section itself
			const wrapper = section.closest('.shopify-section');
			if (wrapper) {
				wrapper.remove();
			} else {
				section.remove();
			}
		});
	}

	function replaceCartTextForEU() {
		// Replace "Add to Cart" with "Add to Quote" on PDP buttons and remove other contents
		document.querySelectorAll('[data-action="add-to-cart"]').forEach(function(btn) {
			const textSpan = btn.querySelector('span:first-child');
			if (textSpan && textSpan.textContent.trim().toLowerCase() === 'add to cart') {
				textSpan.textContent = 'Add to Quote';
				btn.innerHTML = '';
				btn.appendChild(textSpan);
			}
		});

		// Replace "Cart" with "Quote" in header navigation links
		const cartLinks = document.querySelectorAll('a[data-drawer-id="sidebar-cart"]');
		
		cartLinks.forEach(function(link) {
			// Check if the link itself has the Heading class, or if it has a child with it
			let headingElement = link.classList.contains('Heading') ? link : link.querySelector('.Heading.u-h6');
			
			if (headingElement) {
				const text = headingElement.textContent;
				// Replace "Cart" with "Quote" (preserving the count in parentheses)
				headingElement.textContent = text.replace(/Cart/gi, 'Quote');
			}
		});

		// Replace cart drawer title
		const drawerTitle = document.querySelector('.Drawer__Title.Heading.u-h4');
		if (drawerTitle && drawerTitle.textContent.toLowerCase().includes('cart')) {
			drawerTitle.textContent = 'QUOTE';
		}
	}

	const EU_SHIPPING_HTML = '<p style="margin: 0;"><strong>Standard Delivery</strong> throughout Europe: 1-2 weeks.</p><p style="margin: 0;"><strong>White Glove Delivery</strong> throughout Europe: 1-3 weeks.</p>';

	function replaceShippingTextForEU() {
		// Find the shipping tab content and replace with EU shipping info
		const shippingTab = document.querySelector('[data-et-handle="tabs-shipping"] .easytabs-content-holder');
		if (shippingTab && shippingTab.innerHTML !== EU_SHIPPING_HTML) {
			shippingTab.innerHTML = EU_SHIPPING_HTML;
		}
	}

	// EU navigation link replacements - US URL → EU URL
	const EU_LINK_REPLACEMENTS = {
		'/pages/trade-program': '/pages/trade-program-eu',
		'/pages/shipping-delivery': '/pages/shipping-delivery-eu',
		'/pages/terms-and-conditions': '/pages/terms-of-service-eu',
		'/collections/in-stock': '/pages/european-stocking-program'
	};

	// US collection paths that should redirect to EU In Stock for EU visitors
	const EU_REDIRECT_PATHS = [
		'/collections/in-stock-all-outdoor',
		'/collections/in-stock-weather-covers-ships-within-3-days',
		'/collections/in-stock-swatches-ships-within-3-days',
		'/collections/in-stock-throws-ships-within-3-days',
		'/collections/in-stock-outdoor-sconces-ships-within-3-days',
		'/collections/in-stock-outdoor-bar-carts-ships-within-3-days',
		'/collections/in-stock-living',
		'/collections/in-stock-outdoor-fire-tables',
		'/collections/in-stock-outdoor-bar-tables',
		'/collections/in-stock-outdoor-sectionals',
		'/collections/in-stock-outdoor-lounge-chairs',
		'/collections/in-stock-outdoor-side-tables',
		'/collections/in-stock-dining',
		'/collections/in-stock-pool',
		'/collections/in-stock-outdoor-day-beds',
		'/collections/in-stock-outdoor-dining-chairs',
		'/collections/in-stock-outdoor-sun-lounges',
		'/collections/in-stock-outdoor-coffee-tables',
		'/collections/in-stock-outdoor-sofas',
		'/collections/in-stock-outdoor-dining-tables',
		'/collections/in-stock-outdoor-ottomans',
		'/collections/in-stock-outdoor-counter-and-bar-stools',
		'/collections/in-stock-outdoor-cabanas',
		'/collections/sale-outdoor'
	];
	const EU_REDIRECT_DESTINATION = '/collections/eu-in-stock';

	function redirectToEUCollectionIfNeeded() {
		if (window.Shopify && window.Shopify.designMode) return false;

		const currentPath = window.location.pathname;
		const normalizedPath = currentPath.endsWith('/') ? currentPath.slice(0, -1) : currentPath;

		if (EU_REDIRECT_PATHS.includes(normalizedPath)) {
			window.location.href = EU_REDIRECT_DESTINATION;
			return true;
		}
		return false;
	}

	function replaceNavigationLinksForEU() {
		// Replace all matching links in the document
		Object.keys(EU_LINK_REPLACEMENTS).forEach(function(usUrl) {
			const euUrl = EU_LINK_REPLACEMENTS[usUrl];
			
			// Find all links that match the US URL (exact match or with trailing slash)
			document.querySelectorAll('a[href="' + usUrl + '"], a[href="' + usUrl + '/"]').forEach(function(link) {
				link.setAttribute('href', euUrl);
			});
		});
	}

	function removeUSInStockMenuItems() {
		// Remove US "IN-STOCK" from desktop nav (link to in-stock-categories)
		const usDesktopItem = document.querySelector('.Header__MainNav .HorizontalList__Item:not(.HorizontalList__Item--eu-instock) > a[href*="in-stock-categories"]');
		if (usDesktopItem) {
			usDesktopItem.closest('.HorizontalList__Item').remove();
		}

		// Remove US "IN-STOCK" from mobile sidebar nav (collapsible with button text "IN-STOCK")
		const sidebarNav = document.querySelector('.SidebarMenu__Nav--primary');
		if (sidebarNav) {
			sidebarNav.querySelectorAll(':scope > .Collapsible:not(.Collapsible--eu-instock)').forEach(function(collapsible) {
				const btn = collapsible.querySelector('.Collapsible__Button');
				if (btn && btn.textContent.trim().replace(/\s+/g, ' ').toUpperCase() === 'IN-STOCK') {
					collapsible.remove();
				}
			});
		}
	}

	function addEUInStockMenuItem() {
		// Add to desktop header navigation
		const mainNav = document.querySelector('.Header__MainNav .HorizontalList');
		if (mainNav) {
			const inStockItem = document.createElement('li');
			inStockItem.className = 'HorizontalList__Item HorizontalList__Item--eu-instock';
			inStockItem.innerHTML = '<a href="/pages/european-stocking-program" class="Heading u-h6">IN STOCK</a>';
			mainNav.insertBefore(inStockItem, mainNav.firstChild);
		}

		// Add to mobile sidebar navigation
		const sidebarNav = document.querySelector('.SidebarMenu__Nav--primary');
		if (sidebarNav) {
			const inStockCollapsible = document.createElement('div');
			inStockCollapsible.className = 'Collapsible Collapsible--eu-instock';
			inStockCollapsible.innerHTML = '<a href="/pages/european-stocking-program" class="Collapsible__Button Heading Link Link--primary u-h6">IN STOCK</a>';
			sidebarNav.insertBefore(inStockCollapsible, sidebarNav.firstChild);
		}

		// Remove the US IN-STOCK items from both desktop and mobile
		removeUSInStockMenuItems();
	}

	let isModifyingFilters = false;

	function modifyCollectionFiltersForEU() {
		// Only apply on /collections/eu-in-stock page
		if (!window.location.pathname.startsWith('/collections/eu-in-stock')) {
			return;
		}

		// Prevent re-entry from MutationObserver
		if (isModifyingFilters) {
			return;
		}
		isModifyingFilters = true;

		document.querySelectorAll('.Linklist__Item label').forEach(function(label) {
			// Skip if already processed
			if (label.hasAttribute('data-eu-processed')) {
				return;
			}

			const text = label.textContent;
			// Check if count is 0 - if so, hide the entire filter item
			const zeroMatch = text.match(/\s*\(0\)\s*$/);
			if (zeroMatch) {
				const listItem = label.closest('.Linklist__Item');
				if (listItem) {
					listItem.style.display = 'none';
				}
				label.setAttribute('data-eu-processed', 'true');
				return;
			}
			// Remove count numbers from filter items - e.g., "LOUNGE CHAIRS (2)" -> "LOUNGE CHAIRS"
			const newText = text.replace(/\s*\(\d+\)\s*$/, '');
			if (newText !== text) {
				label.textContent = newText;
			}
			label.setAttribute('data-eu-processed', 'true');
		});

		isModifyingFilters = false;
	}

	function setupFilterObserver() {
		// Only setup observer on /collections/eu-in-stock page
		if (!window.location.pathname.startsWith('/collections/eu-in-stock')) {
			return;
		}

		// Run immediately
		modifyCollectionFiltersForEU();

		// Observe DOM changes to re-apply when filters update (new elements won't have data-eu-processed)
		const filterContainer = document.querySelector('.CollectionFilters');
		if (filterContainer) {
			const observer = new MutationObserver(function(mutations) {
				modifyCollectionFiltersForEU();
			});
			observer.observe(filterContainer, { childList: true, subtree: true });
		}

		// Also listen for Shopify's section re-render events
		document.addEventListener('shopify:section:load', modifyCollectionFiltersForEU);
	}

	function getContinent(countryData) {
		if (!countryData || !countryData.continent || !countryData.continent.code) return false;
		return countryData.continent.code;
	}

	function getCountryCode(countryData) {
		if (!countryData || !countryData.country || !countryData.country.iso_code) return false;
		return countryData.country.iso_code;
	}

	function isMENACountry(countryCode) {
		return !!countryCode && MENA_COUNTRY_CODES.indexOf(countryCode) !== -1;
	}

	function showNonUSPopup() {
		const popup = getPopupElement();
		if (popup) {
			popup.style.display = 'flex';
		}
	}

	function hideNonUSPopup() {
		const popup = getPopupElement();
		if (popup) {
			popup.style.display = 'none';
		}
	}

	function showEUPopup() {
		const popup = getEUPopupElement();
		if (popup) {
			popup.style.display = 'flex';
		}
	}

	function hideEUPopup() {
		const popup = getEUPopupElement();
		if (popup) {
			popup.style.display = 'none';
		}
	}

	function showEUWelcomePopup() {
		const popup = getEUWelcomePopupElement();
		if (popup) {
			popup.style.display = 'flex';
		}
	}

	function hideEUWelcomePopup() {
		const popup = getEUWelcomePopupElement();
		if (popup) {
			popup.style.display = 'none';
		}
	}

	function showAUWelcomePopup() {
		const popup = getAUWelcomePopupElement();
		if (popup) {
			popup.style.display = 'flex';
		}
	}

	function hideAUWelcomePopup() {
		const popup = getAUWelcomePopupElement();
		if (popup) {
			popup.style.display = 'none';
		}
	}

	function showMENAWelcomePopup() {
		const popup = getMENAWelcomePopupElement();
		if (popup) {
			// No expiry: remember the display only for this browser session.
			setCookie(HARBOUR_MENA_SESSION_SHOWN_COOKIE, 'true');
			popup.style.display = 'flex';
		}
	}

	function scheduleMENAWelcomePopup() {
		if (getCookie(HARBOUR_MENA_SESSION_SHOWN_COOKIE)) return;

		let arrivalTime = Number(getCookie(HARBOUR_MENA_SESSION_STARTED_COOKIE));
		if (!arrivalTime) {
			arrivalTime = pageArrivalTime;
			setCookie(HARBOUR_MENA_SESSION_STARTED_COOKIE, arrivalTime);
		}

		// Carry the countdown across pages and share the display state across tabs.
		const remainingDelay = Math.max(0, MENA_POPUP_DELAY - (Date.now() - arrivalTime));
		setTimeout(function () {
			if (!getCookie(HARBOUR_MENA_SESSION_SHOWN_COOKIE)) {
				showMENAWelcomePopup();
			}
		}, remainingDelay);
	}

	function hideMENAWelcomePopup() {
		const popup = getMENAWelcomePopupElement();
		if (popup) {
			popup.style.display = 'none';
		}
	}

	function applyEUExperience() {
		// Redirect US collection pages to EU equivalent
		if (redirectToEUCollectionIfNeeded()) {
			return; // Stop execution, page is redirecting
		}

		applyEUVisitorFlag();

		// Remove US-only sections for EU visitors
		removeRegionSections('us');

		replaceCartTextForEU();
		replaceNavigationLinksForEU();
		addEUInStockMenuItem();
		setupFilterObserver();
		// modifyCollectionFiltersForEU();
		
		// Replace shipping tab content - retry a few times as Easy Tabs may load later
		let shippingRetries = 0;
		const maxShippingRetries = 10;
		function tryReplaceShipping() {
			const shippingTab = document.querySelector('[data-et-handle="tabs-shipping"] .easytabs-content-holder');
			if (shippingTab) {
				replaceShippingTextForEU();
			} else if (shippingRetries < maxShippingRetries) {
				shippingRetries++;
				setTimeout(tryReplaceShipping, 500);
			}
		}
		tryReplaceShipping();
	}

	function applySavedSitePreference() {
		const sitePreference = getCookie(HARBOUR_EU_COOKIE);

		if (sitePreference === 'eu') {
			applyEUExperience();
			return true;
		}

		if (sitePreference === 'us') {
			removeRegionSections('eu');
			return true;
		}

		return false;
	}

	function handleGeoIP(countryData) {
		const continent = getContinent(countryData);

		// Target-country visitors get SANIPEX GROUP once per browser session.
		if (isMENACountry(getCountryCode(countryData)) && !isCurrentlyOnAUStore()) {
			if (!savedSitePreferenceApplied) removeRegionSections('eu');
			scheduleMENAWelcomePopup();
			return;
		}

		if (savedSitePreferenceApplied) {
			return;
		}

		if (continent === 'EU') {
			// Apply EU experience by default for EU visitors.
			applyEUExperience();

			// Show welcome popup only if no preference has been set yet.
			showEUWelcomePopup();
			return; // Don't show the general international popup
		}

		// US/non-EU visitors: remove EU-only sections
		removeRegionSections('eu');

		// Oceania visitors on the US store: offer the dedicated AU store
		if (continent === 'OC' && !isCurrentlyOnAUStore() && !getCookie(HARBOUR_AU_COOKIE)) {
			showAUWelcomePopup();
			return;
		}

		// Show general international popup for non-NA, non-EU, non-OC visitors
		if (!getCookie(HARBOUR_INTERNATIONAL_COOKIE)) {
			if (continent !== 'NA' && continent !== 'EU' && continent !== 'OC') {
				showNonUSPopup();
			}
		}
	}

	function initializeGeoIP() {
		// Allow forcing a region via URL parameter for testing (e.g. ?force_region=eu, ?force_region=au, ?force_region=mena)
		const urlParams = new URLSearchParams(window.location.search);
		const forceRegion = urlParams.get('force_region');
		if (forceRegion === 'eu') {
			applyEUExperience();
			return;
		}
		if (forceRegion === 'au' && !isCurrentlyOnAUStore()) {
			showAUWelcomePopup();
			return;
		}
		if (forceRegion === 'mena') {
			// Testing bypasses session suppression but keeps the production delay.
			setTimeout(showMENAWelcomePopup, MENA_POPUP_DELAY);
			return;
		}

		// shopharbour.eu redirects here with ?region=eu. Persist preference so
		// subsequent navigations (which lose the param) stay on EU silently,
		// then show the EU welcome before asking for language.
		const region = urlParams.get('region');
		if (region === 'eu') {
			setCookie(HARBOUR_EU_COOKIE, 'eu', EU_COOKIE_EXPIRY_DAYS);
			applyEUExperience();
			showEUWelcomePopup();
			return;
		}

		if (!savedSitePreferenceApplied) {
			savedSitePreferenceApplied = applySavedSitePreference();
		}

		if (typeof geoip2 === 'undefined') {
			if (retryCount < MAX_RETRIES) {
				retryCount++;
				setTimeout(initializeGeoIP, GEOIP_RETRY_DELAY);
			}
			return;
		}

		geoip2.country(
			function (countryData) {
				handleGeoIP(countryData);
			},
			function (error) {
				console.error('[GeoIP] Error:', error);
			}
		);
	}

	initializeGeoIP();

	// Keep EU language trigger label in sync with Weglot language changes
	syncEULanguageTriggerLabel();
	if (!bindWeglotLanguageListener()) {
		let weglotRetries = 0;
		const maxWeglotRetries = 10;
		const retryBindWeglot = function() {
			if (bindWeglotLanguageListener()) {
				syncEULanguageTriggerLabel();
				return;
			}
			if (weglotRetries < maxWeglotRetries) {
				weglotRetries++;
				setTimeout(retryBindWeglot, 300);
			}
		};
		retryBindWeglot();
	}

	document.addEventListener('click', function (event) {
		if (event.target && event.target.closest && event.target.closest('[data-eu-language-trigger="true"]')) {
			event.preventDefault();
			showEUPopup();
			return;
		}

		if (event.target && event.target.id === 'geoip-understand-button') {
			setCookie(HARBOUR_INTERNATIONAL_COOKIE, 'true', COOKIE_EXPIRY_DAYS);
			hideNonUSPopup();
		}

		// Handle EU popup language selection (legacy, kept for compatibility)
		if (event.target && event.target.hasAttribute('data-locale-code')) {
			const languageUrl = event.target.getAttribute('data-language-url');
			setCookie(HARBOUR_EU_COOKIE, 'eu', EU_COOKIE_EXPIRY_DAYS);
			hideEUPopup();

			if (languageUrl && !(window.Shopify && window.Shopify.designMode)) {
				window.location.href = languageUrl;
			}
		}

		// Handle EU welcome popup - Enter Harbour Europe button
		if (event.target && event.target.id === 'geoip-eu-welcome-continue') {
			setCookie(HARBOUR_EU_COOKIE, 'eu', EU_COOKIE_EXPIRY_DAYS);
			hideEUWelcomePopup();
			showEUPopup();
		}

		// Handle EU welcome popup - Visit Harbour US link
		if (event.target && event.target.id === 'geoip-eu-welcome-us') {
			event.preventDefault();
			setCookie(HARBOUR_EU_COOKIE, 'us', EU_COOKIE_EXPIRY_DAYS);
			hideEUWelcomePopup();
			// Reload the page to show US experience (without EU styles)
			if (!(window.Shopify && window.Shopify.designMode)) {
				const url = new URL(window.location.href);
				url.searchParams.delete('region');
				const destination = url.toString();
				if (destination === window.location.href) {
					window.location.reload();
				} else {
					window.location.href = destination;
				}
			}
		}

		// Handle AU welcome popup - Visit Harbour Australia button
		if (event.target && event.target.id === 'geoip-au-welcome-continue') {
			setCookie(HARBOUR_AU_COOKIE, 'au', AU_COOKIE_EXPIRY_DAYS);
			hideAUWelcomePopup();
			if (!(window.Shopify && window.Shopify.designMode)) {
				window.location.href = HARBOUR_AU_STORE_URL;
			}
		}

		// Handle AU welcome popup - Stay on Harbour US link
		if (event.target && event.target.id === 'geoip-au-welcome-us') {
			event.preventDefault();
			setCookie(HARBOUR_AU_COOKIE, 'us', AU_COOKIE_EXPIRY_DAYS);
			hideAUWelcomePopup();
		}

		// Handle MENA welcome popup - Visit SANIPEX GROUP link (opens in a new tab)
		if (event.target && event.target.id === 'geoip-mena-welcome-continue') {
			hideMENAWelcomePopup();
		}

		// Handle MENA welcome popup - Stay on Harbour US link
		if (event.target && event.target.id === 'geoip-mena-welcome-us') {
			event.preventDefault();
			hideMENAWelcomePopup();
		}
	});

	document.addEventListener('harbour:eu-language-selected', function(event) {
		if (event && event.detail) {
			const code = event.detail.code;
			let label = event.detail.label;
			if (!label && code) {
				label = getLanguageLabelFromCode(code);
			}
			if (label) {
				setEULanguageTriggerLabel(label, code);
			}
		}
	});

	// Watch for cart drawer opening and replace text for EU visitors
	document.addEventListener('DOMContentLoaded', function() {
		if (!document.documentElement.classList.contains('eu-visitor')) return;

		const cartDrawer = document.getElementById('sidebar-cart');
		if (cartDrawer) {
			const cartObserver = new MutationObserver(function(mutations) {
				mutations.forEach(function(mutation) {
					if (mutation.type === 'attributes' && mutation.attributeName === 'aria-hidden') {
						const target = mutation.target;
						if (target.id === 'sidebar-cart' && target.getAttribute('aria-hidden') === 'false') {
							// Cart drawer just opened, replace text
							setTimeout(replaceCartTextForEU, 50);
						}
					}
				});
			});

			cartObserver.observe(cartDrawer, { attributes: true });
		}
	});
});
